export default __webpack_public_path__ + "static/kev-brown-d652e80c7ab33318ffda55ade25e74d4.png";